import { TextWithLabel as Text, StringHelper } from "@octopusdeploy/design-system-octopus-components";
import { useAggregateAPIOperationStatus, useMutation } from "@octopusdeploy/octopus-react-client";
import { links } from "@octopusdeploy/portal-routes";
import { useState } from "react";
import OkDialogLayout from "~/components/DialogLayout/OkDialogLayout";
import { useSpaceAwareNavigation } from "~/components/Navigation/SpaceAwareNavigation/useSpaceAwareNavigation";
import { required } from "~/components/form";
function SendTestEmail() {
    const [testEmailAddress, setTestEmailAddress] = useState<string>("");
    const { navigate } = useSpaceAwareNavigation();
    const { errors, isInProgress } = useAggregateAPIOperationStatus();
    const looksLikeAnEmail = (email: string) => !StringHelper.isNullOrWhiteSpace(email) && email.indexOf("@") !== -1;
    const { execute: createSendEmailTask } = useMutation({
        name: "Create Send Test Email Task",
        action: async (repository) => await repository.Tasks.createSendTestEmailTask(testEmailAddress),
        afterComplete: async (_, createdTask) => navigate(links.taskPage.generateUrl({ taskId: createdTask.Id })),
    });
    return (<OkDialogLayout title="Test Email" errors={errors} busy={isInProgress} okButtonDisabled={!looksLikeAnEmail(testEmailAddress)} onOkClick={() => createSendEmailTask()}>
            <p>Who would you like to send the test email to?</p>
            <div>
                <Text value={testEmailAddress} onChange={(value) => setTestEmailAddress(value)} label="Test email" placeholder="test@example.com" validate={required("Please enter an email address")} autoFocus={true}/>
            </div>
        </OkDialogLayout>);
}
export default SendTestEmail;
